/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./autocompleteReorderable.vue?vue&type=template&id=d32a1300"
import script from "./autocompleteReorderable.vue?vue&type=script&lang=js"
export * from "./autocompleteReorderable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports